import p21s from './p21s'

export const pboxProducts = {
  p21s
}
